module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tree', {
    staticClass: "tree",
    attrs: {
      "data": _vm.treeData,
      "layoutType": "radial",
      "type": "cluster",
      "duration": 50,
      "nodeText": "name",
      "margin-x": 0,
      "margin-y": 0,
      "person": _vm.selectedPerson,
      "data-step": "2",
      "data-intro": "This is a family-level phylogeny. You can click on the names at each tip of the tree to learn more about each family and our model results."
    },
    on: {
      "clicked": _vm.clicked,
      "hover": _vm.hover
    }
  }), (_vm.hoveredNode) ? _c('div', {
    ref: "floatingCard",
    staticClass: "ui card floating-card",
    style: (_vm.cardStyle)
  }, [(_vm.hoveredImage) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.hoveredImage
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.hoveredNode.name))]), _c('div', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.hoveredTaxonomy))]), (_vm.hoveredSummary) ? _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.hoveredSummary))]) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "ui raised container segment"
  }, [_c('my-header', {
    attrs: {
      "main": _vm.selectedLeaf ? _vm.selectedLeaf : 'Select a Node to View Summary',
      "sub": _vm.common
    }
  }), (_vm.selectedTree === 'main') ? _c('div', {
    staticClass: "ui divider"
  }) : _vm._e(), (_vm.selectedTree === 'main') ? _c('table', {
    staticClass: "ui center aligned single line table"
  }, [_vm._m(0), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.people.lwr_95))]), _c('td', [_vm._v(_vm._s(_vm.people.estimate))]), _c('td', [_vm._v(_vm._s(_vm.people.upr_95))])])])]) : _vm._e(), (_vm.selectedLeaf) ? _c('div', {
    staticClass: "ui horizontal divider",
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Summary")]) : _vm._e(), _c('wiki-summary', {
    attrs: {
      "selected": _vm.selectedLeaf
    }
  })], 1), _c('attribution')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Lower Bound (95% CRI)")]), _c('th', [_vm._v("Mean Estimated Effect")]), _c('th', [_vm._v("Upper Bound (95% CRI)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37d49db0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhyloTree.vue
// module id = 250
// module chunks = 1